<script setup>
  defineProps({
    banner: Object
  })
</script>

<template>
  <div>
    <a :href="banner.url" target="_blank" tabindex="-1">
      <img :src="banner.image">
    </a>
  </div>
</template>
